<div class="center-container">
  <div class="title">{{ 'common.redirecting' | translate }}</div>
  <agmo-loading></agmo-loading>
</div>
